const paths = {
  main: '/mypage',
  edit: '/mypage/edit',
  card: '/mypage/card',
  leave: '/mypage/leave',
};

export default paths;
